import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapUnitToApiUnitDto = (values: ICreateUnitForm): IPostNewUnit | {} => {
  let dataMapping: IPostNewUnit;

  if (values.placeID === undefined) { return {} }
  
  dataMapping = {
    description: values.description,
    placeID: +values.placeID !== 0 ? +values.placeID : null,
    unID: values.unID,
    sapCode: values.sapCode !== "" ? values.sapCode : null,
    isEmporiki: values.isEmporiki,
    isCiti: values.isCiti, 
  }
  
  return dataMapping;
}


export const createUnit = ( {data} : {data: ICreateUnitForm }): Promise<string> => {
  const store = mapUnitToApiUnitDto(data);
  return axiosDefaultApi.post(`/api/Units/InsertUnit`, store);
};

type QueryFnType = typeof createUnit;

type UseCreateUnitOptions = {
  data: IPostNewUnit | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateUnit = ({ config }: UseCreateUnitOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της Μονάδας.`, 500);
            console.error('Couldnt create new store', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllUnits"])
            addNotification(`Η Μονάδα Δημιουργήθηκε.`, 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createUnit,
    })
}